/*
    * Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
*/
import { ActionTree } from "vuex";
import { RootState } from "../../types";
import { App } from "./types";

/*
    * Used for changing the state or data
*/
export const actions: ActionTree<App, RootState> = {
    /*
        * v-app-bar triggered button action event
    */
    _appBtnClick({ commit }, payload) {
        commit("_appBtnClick", payload);
    },

    /*
        * v-app-bar triggered tab click event
    */
    _appTabClick({ commit }, payload) {
        commit("_appTabClick", payload);
    },

    /*
        * v-app-bar triggered tile click event
    */
    _appTileClick({ commit }, payload) {
        commit("_appTileClick", payload);
    },

    /*
        * Get the module group based on the permission
    */
    _getModuleGroup({ commit }, modulGroups) {
        commit("_getModuleGroup", modulGroups);
    },

    /*
        * Application About details
    */
    _appAbout({ commit }, messages) {
        commit("_appAbout", messages);
    },

    /*
        * Vuex error log 
    */
    _appErrorLog({ commit }, messages) {
        commit("_appErrorLog", messages);
    }
};
